import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import { Videos, ChannelCard } from "./";
import { fetchFromApi } from "./utils/fetchFromApi";

const ChannelDetail = () => {
  const [channelDetail, setChannelDetail] = useState(null);
  const [videos, setVideos] = useState([]);

  const { id } = useParams();

  console.log(channelDetail, videos);

  useEffect(() => {
    fetchFromApi(`channels?parts=snippet&id=${id}`)
      .then((data) => setChannelDetail(data?.items[0]));

    fetchFromApi(`search?channelId=${id}&part=snippet&order=date`)
      .then((data) => setVideos(data?.items));
  }, [id]);

  return (
    <Box minHeight={"95vh"}
    sx={{width: {md:'100%'}}}
    >
      <Box>
      <div 
      style={{
        background: "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(108,153,95,0.9549641756116509) 35%, rgba(71,173,149,1) 57%, rgba(64,177,159,0.8877372848553484) 61%, rgba(0,212,255,1) 100%)",
        zIndex: 10,
        height: '200px'
      }}
      />
      <ChannelCard channelDetail={channelDetail} 
      marginTop={"-90px"}/>
      </Box>

      <Box display={"flex"} p={2}>
      <Box sx={{mr: {sm: "120px"}}} />
      <Videos videos={videos} />
      </Box>
    </Box>
  );
};

export default ChannelDetail;
